// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

import {Op} from './op.js'
import {Uuid} from './uuid.js'

export class NoteBundle {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): NoteBundle {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  static getRootAsNoteBundle(bb: flatbuffers.ByteBuffer, obj?: NoteBundle): NoteBundle {
    return (obj || new NoteBundle()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  static getSizePrefixedRootAsNoteBundle(bb: flatbuffers.ByteBuffer, obj?: NoteBundle): NoteBundle {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH)
    return (obj || new NoteBundle()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  noteId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? (obj || new Uuid()).__init(this.bb_pos + offset, this.bb!) : null
  }

  legacyNoteId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 6)
    return offset ? (obj || new Uuid()).__init(this.bb_pos + offset, this.bb!) : null
  }

  editorSite(): number {
    const offset = this.bb!.__offset(this.bb_pos, 8)
    return offset ? this.bb!.readUint16(this.bb_pos + offset) : 0
  }

  editorUserId(): string | null
  editorUserId(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null
  editorUserId(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 10)
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null
  }

  createdAt(): bigint {
    const offset = this.bb!.__offset(this.bb_pos, 12)
    return offset ? this.bb!.readUint64(this.bb_pos + offset) : BigInt('0')
  }

  creatorUserId(): string | null
  creatorUserId(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null
  creatorUserId(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 14)
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null
  }

  ops(index: number, obj?: Op): Op | null {
    const offset = this.bb!.__offset(this.bb_pos, 16)
    return offset
      ? (obj || new Op()).__init(this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4), this.bb!)
      : null
  }

  opsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 16)
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0
  }

  schemaVersion(): number {
    const offset = this.bb!.__offset(this.bb_pos, 18)
    return offset ? this.bb!.readUint16(this.bb_pos + offset) : 0
  }

  static startNoteBundle(builder: flatbuffers.Builder) {
    builder.startObject(8)
  }

  static addNoteId(builder: flatbuffers.Builder, noteIdOffset: flatbuffers.Offset) {
    builder.addFieldStruct(0, noteIdOffset, 0)
  }

  static addLegacyNoteId(builder: flatbuffers.Builder, legacyNoteIdOffset: flatbuffers.Offset) {
    builder.addFieldStruct(1, legacyNoteIdOffset, 0)
  }

  static addEditorSite(builder: flatbuffers.Builder, editorSite: number) {
    builder.addFieldInt16(2, editorSite, 0)
  }

  static addEditorUserId(builder: flatbuffers.Builder, editorUserIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, editorUserIdOffset, 0)
  }

  static addCreatedAt(builder: flatbuffers.Builder, createdAt: bigint) {
    builder.addFieldInt64(4, createdAt, BigInt('0'))
  }

  static addCreatorUserId(builder: flatbuffers.Builder, creatorUserIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(5, creatorUserIdOffset, 0)
  }

  static addOps(builder: flatbuffers.Builder, opsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(6, opsOffset, 0)
  }

  static createOpsVector(builder: flatbuffers.Builder, data: flatbuffers.Offset[]): flatbuffers.Offset {
    builder.startVector(4, data.length, 4)
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!)
    }
    return builder.endVector()
  }

  static startOpsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4)
  }

  static addSchemaVersion(builder: flatbuffers.Builder, schemaVersion: number) {
    builder.addFieldInt16(7, schemaVersion, 0)
  }

  static endNoteBundle(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject()
    builder.requiredField(offset, 4) // note_id
    builder.requiredField(offset, 10) // editor_user_id
    builder.requiredField(offset, 14) // creator_user_id
    builder.requiredField(offset, 16) // ops
    return offset
  }

  static finishNoteBundleBuffer(builder: flatbuffers.Builder, offset: flatbuffers.Offset) {
    builder.finish(offset)
  }

  static finishSizePrefixedNoteBundleBuffer(builder: flatbuffers.Builder, offset: flatbuffers.Offset) {
    builder.finish(offset, undefined, true)
  }
}
